import Immutable from 'immutable';
import {
  FLAG_KIDS_ON_ITINERARY_ACTIVITY,
  GET_KIDS_ON_ITINERARY,
  CLEAR_KIDS_ON_ITINERARY,
} from '../../../actions/types';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  current: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case FLAG_KIDS_ON_ITINERARY_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_KIDS_ON_ITINERARY:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_KIDS_ON_ITINERARY:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
